import React from "react"
import SoftButton from "../../common/SoftButton";
import { ArrowRight } from "@phosphor-icons/react";

const SuitItem = ({image, title, description, buttonLabel, link}) => {

  return (
    <React.Fragment>
      <a className="w-full justify-items-center col-span-2 xl:col-span-1" href={link ?? '#'}>
        <div className="w-auto max-w-80 flex flex-col items-center justify-items-start">
            <img src={image} alt={title} />
            <h2 className="text-center !text-xl md:text-2xl">{title}</h2>
            <p className="suit-item-desc">{description}</p>

            <div className="text=[#464646] mt-4 text-sm md:text-base">
              <SoftButton
                label={buttonLabel}
                icon={<ArrowRight size={20} weight="light" />}
              />
            </div>
        </div>
      </a>
    </React.Fragment>
  );
}

export default SuitItem